import {TemplateResponseBody, useLazyDownloadTemplateQuery} from '@dms/api/core';
import {handleApiError} from '@dms/shared';

export const useDownloadTemplate = () => {
  const [downloadTemplate] = useLazyDownloadTemplateQuery();

  const handleDownloadTemplate = (
    template: TemplateResponseBody & {isPrimary: boolean; definitionType: 'docx' | 'html'}
  ) => {
    downloadTemplate({templateId: template.id})
      .unwrap()
      .then((data) => downloadBlobFile(data, `${template.title}.${template.definitionType}`))
      .catch(handleApiError);
  };

  return [handleDownloadTemplate];
};

const downloadBlobFile = (file: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
